import React from "react";
import HomeAbout from "../../assets/img/home/about-hm.webp";
import {Grid} from "@mui/system";
import style from "../../assets/css/home.module.scss";
import {Button} from "@mui/material";
import {Link} from "react-router-dom";

function About() {
  return (
    <>
      <section className={style.aboutSection}>
        <Grid
          container
          maxWidth="lg"
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 6, sm: 12, xl: 6}}>
            <div className={style.hmAboutImgBox}>
              <img src={HomeAbout} alt="home" />
            </div>
          </Grid>
          <Grid size={{xs: 12, lg: 6, sm: 12, xl: 6}}>
            <div className={style.hmAboutContentBox}>
              <div>
                <h2> About Us </h2>
                <p>
                  Associated International Brokers, Inc AIB is a premier
                  brokerage specializing in Jewelers Block Insurance, offering
                  tailored risk solutions for jewelers, wholesalers,
                  manufacturers, retailers, art galleries, and pawnshops
                  worldwide. With a deep-rooted legacy in the jewelry trade and
                  decades of expertise in specialty insurance, we provide
                  comprehensive coverage for high-value assets, trade shows,
                  global shipments, and client entrustments.
                </p>

                <Link to="/about-us">
                  <Button varient="outline"> Know More </Button>
                </Link>
              </div>
            </div>
          </Grid>

          <Grid size={{xs: 12, lg: 9}}>
            <div className={style.hmAboutText}>
              <p className={style.hmAboutContentBox_p}>
                Jewelry Retailers, Diamond and Jewelry Wholesalers,
                Manufacturers who trade Diamonds, Precious metals and watches
                require a knowledgeable industry expert when choosing their
                insurance carrier.
              </p>
              <Link to="/jewelers-block">
                <Button varient="contained"> Jewelers Block </Button>
              </Link>
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  );
}

export default About;
